{
  "EnablerptrequestauditLabel": "Ativar saída de auditoria de solicitação de relatório:",
  "Audit_SectionHeader": "Auditoria",
  "Audit_SectionPara": "Aviso: ative a configuração a seguir somente quando solicitado por um membro da administração do aplicativo ou da equipe de suporte.",
  "NAME": "Audit"
}